export enum Roles {
	GRAPHICS_DOCUMENT = 'graphics-document',
	GRAPHICS_OBJECT = 'graphics-object',
	GRAPHICS_SYMBOL = 'graphics-symbol',
	GROUP = 'group',
	DOCUMENT = 'document',
	CHECKBOX = 'checkbox',
	BUTTON = 'button',
	MENU = 'menu',
	MENU_ITEM = 'menuitem',
	IMG = 'img',
}
